import React from 'react';

interface AccountDeletionProps {
  appName?: string;
  onClose: () => void;
}

const AccountDeletionRideRoster: React.FC<AccountDeletionProps> = ({ appName = 'Ride Roster', onClose }) => {
  return (
    <div className="fixed inset-0 z-[300] bg-black/95 backdrop-blur-xl animate-in fade-in duration-300 overflow-y-auto">
      <button 
        onClick={onClose}
        className="fixed top-8 right-8 z-[310] size-14 bg-white text-black flex items-center justify-center hover:bg-primary hover:text-white transition-all group"
      >
        <span className="material-symbols-outlined transform group-hover:rotate-90 transition-transform">close</span>
      </button>

      <div className="max-w-[700px] mx-auto px-6 py-32 text-white/80">
        <h1 className="text-5xl lg:text-7xl font-black uppercase tracking-tighter leading-none mb-4 italic text-white flex flex-col gap-2">
          <span>Account</span>
          <span>Deletion</span>
        </h1>
        <p className="text-xl text-primary font-bold tracking-widest uppercase mb-12 border-b border-white/10 pb-6">
          {appName}
        </p>

        <div className="space-y-12 font-light leading-relaxed text-lg">
          <section className="space-y-6">
            <p>
              We value your privacy. If you wish to delete your account and all associated data from <strong className="text-white">{appName}</strong>, 
              please follow the instructions below.
            </p>

            <div className="bg-white/5 border border-white/10 p-8 space-y-4 text-white/70">
              <h2 className="text-2xl font-bold text-white uppercase tracking-widest mb-4">
                How to delete your account
              </h2>
              <p>
                To request the deletion of your account and all associated data, please email us directly at:
              </p>
              <a href="mailto:rob@theapps.io" className="text-3xl text-primary font-bold hover:underline block my-6 break-all">
                rob@theapps.io
              </a>
              <p>
                Please ensure you:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Send the request from the email address associated with your {appName} account.</li>
                <li>Include <strong className="text-white">"Account Deletion Request - {appName}"</strong> in the subject line.</li>
              </ul>
            </div>

            <div className="bg-white/5 border border-white/10 p-6 space-y-4 text-white/70">
              <h3 className="text-xl font-bold text-white uppercase tracking-widest mb-4 flex items-center gap-2">
                <span className="material-symbols-outlined text-primary">warning</span>
                Important Information
              </h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Deleting your account is a <strong className="text-white">permanent and irreversible action</strong>.</li>
                <li>All your personal information, settings, and saved schedules will be securely erased.</li>
                <li>Our team will process the permanent deletion of your account and all associated data within 30 days in accordance with data protection laws.</li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletionRideRoster;
